
export const text = `

[ID: A video of a wall made out of flesh. It pulsates rhythmically, as if possessing a heart. The person recording hesitantly touches the wall, recoiling when they make contact. They appear to be called away, and the video ends.]

`